export const debounce = (fn, ms = 300) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
};
export default class Utils {
    static urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
    static utcDateString() {
        return new Date().toISOString().replace("Z", "");
    }
    static utcDateNumber() {
        return new Date().getTime();
    }
    static localDateTimeFormatted(s) {
        const d = new Date(s + "Z");
        return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " +
            ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + "." + ("0" + d.getSeconds()).slice(-2);
    }
    static parseISOStringToDate(s) {
        const b = s.split(/\D+/);
        return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
    }
    static numberToDate(n) {
        if (n) {
            return new Date(n * 1000);
        }
        else {
            return undefined;
        }
    }
    static numberToDateString(n) {
        if (n) {
            return new Date(n * 1000).toISOString().replace("Z", "");
        }
        else {
            return undefined;
        }
    }
    static parseJwt(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        }
        catch (error) {
            throw new Error('token not parseable');
        }
    }
    static async pause(sec) {
        await new Promise(r => setTimeout(r, sec * 1000));
    }
    static replaceObject(arrayOfObjects, newObject) {
        let index = arrayOfObjects.findIndex((obj) => obj.id === newObject.id);
        if (index === -1) {
            arrayOfObjects.push(newObject);
        }
        else {
            arrayOfObjects[index] = newObject;
        }
    }
    static extractBrowserWithVersion(userAgent) {
        const browserPatterns = [
            { pattern: /Chrome\/([\d.]+)/, name: "Chrome" },
            { pattern: /Firefox\/([\d.]+)/, name: "Firefox" },
            { pattern: /Version\/([\d.]+).*Safari/, name: "Safari" }, // Matches Safari with Version
            { pattern: /Edg\/([\d.]+)/, name: "Edge" },
            { pattern: /OPR\/([\d.]+)|Opera\/([\d.]+)/, name: "Opera" },
            { pattern: /MSIE\s([\d.]+)|Trident\/.*rv:([\d.]+)/, name: "Internet Explorer" },
        ];
        for (const { pattern, name } of browserPatterns) {
            const match = userAgent.match(pattern);
            if (match) {
                const version = match[1] || match[2]; // Some patterns may capture version in group 2
                return `${name} ${version}`;
            }
        }
        return "Unknown";
    }
}
//# sourceMappingURL=utils.js.map